export const SPACE = 4
export const LINE_WIDTH = 16

export const Downward = 1
export const Upward = -1
export const Indeterminate = 0
